import {
  AcquisitionChannel,
  AmountOfEmployees,
  DeclaredBusinessType,
  isValidCIF,
  isValidDocumentNumber,
  MerchantCategory,
  Turnover,
} from '@nemuru-eng/js-api-client';
import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import {
  phoneValidation,
  requiredDialCode,
  requiredEmail,
  requiredEnum,
  requiredPhoneNumber,
  requiredString,
} from '@/utils/zodUtils';

export const MerchantCreationSchema = (t: GetTextIdTranslationType) =>
  z
    .object({
      merchantFirstName: requiredString(t),
      merchantLastName: requiredString(t),
      dialCode: requiredDialCode(t),
      phoneNumber: requiredPhoneNumber(t),
      merchantEmail: requiredEmail(t),
      merchantBusinessName: requiredString(t),
      merchantCorporateIdNumber: requiredString(t),
      merchantPostalCode: requiredString(t),
      merchantDeclaredBusinessType: requiredEnum(DeclaredBusinessType, t),
      merchantAmountOfEmployees: requiredEnum(AmountOfEmployees, t),
      merchantCategory: requiredEnum(MerchantCategory, t),
      merchantTurnover: requiredEnum(Turnover, t),
      channel: requiredEnum(AcquisitionChannel, t),
    })
    .strict()
    .refine((data) => !(data.phoneNumber && data.dialCode && !phoneValidation(data)), {
      message: t('INVALID_PHONE_NUMBER'),
      path: ['phoneNumber'],
    })
    .refine(
      (data) =>
        data.merchantDeclaredBusinessType === DeclaredBusinessType.LTD
          ? isValidCIF(data.merchantCorporateIdNumber)
          : isValidDocumentNumber(data.merchantCorporateIdNumber),
      {
        message: t('INVALID_DOCUMENT_NUMBER'),
        path: ['merchantCorporateIdNumber'],
      },
    );

export type MerchantCreationType = z.infer<ReturnType<typeof MerchantCreationSchema>>;
